<script>
import {mapGetters, mapState} from "vuex";
import CommunePartnerCard from "@/components/ui/CommunePartnerCard.vue";

export default {
  name: "MobileCommunePartnerDisplay",
  components: {CommunePartnerCard},
  computed: {
    ...mapGetters("user", ["getDashboardCommunePartners", "showBildungsportal"]),
    ...mapState("bildungsportal", ["contactPersons"]),

    communePartners() {
      if(this.showBildungsportal) return this.contactPersons;
      return this.getDashboardCommunePartners;
    },
  }
}
</script>

<template>
<div class="d-flex flex-column mobile-commune-partner-display">
  <commune-partner-card v-for="partner of communePartners" :key="partner.id" :user-commune-partner="partner" class="mt-4" />
</div>
</template>

<style scoped>
.mobile-commune-partner-display {
  padding: 8px 16px;
}
</style>